import { render, staticRenderFns } from "./ContractRemindModal.vue?vue&type=template&id=52ea7b7a&scoped=true&"
import script from "./ContractRemindModal.vue?vue&type=script&lang=js&"
export * from "./ContractRemindModal.vue?vue&type=script&lang=js&"
import style0 from "./ContractRemindModal.vue?vue&type=style&index=0&id=52ea7b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea7b7a",
  null
  
)

export default component.exports